import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Container, Fade, Typography } from "@mui/material";
import COLORS from "../../../../constants/Colors";
import Styles from "./DetailLoading.module.scss";
import NumberPlate from "../../../common/number-plate/NumberPlate";
import AshokaChakra from "../../../../assets/svgs/ashoka-chakra.svg";

const DetailLoading = ({ closeFunc = () => {}, vehRegNo }) => {
  const loadingText = [
    "Checking with our providers...",
    "Collecting details...",
    "Almost there...",
  ];
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [showText, setShowText] = useState(true);
  useEffect(() => {
    if (currentTextIndex < loadingText.length) {
      const timer = setTimeout(() => {
        if (currentTextIndex < loadingText.length - 1) {
          setShowText(false);
          setTimeout(() => {
            setCurrentTextIndex((prevIndex) => prevIndex + 1);
            setShowText(true);
          }, 500); // Delay between fade out and fade in
        }
      }, 800); // Display each text for 1 second

      return () => clearTimeout(timer);
    }
  }, [currentTextIndex, showText, loadingText.length]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"end"}
        alignItems={"center"}
        width={"calc(100% - 40px)"}
        sx={{
          opacity: "0.8",
          padding: "20px",
        }}
      >
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          color={COLORS.PRIMARY}
          sx={{
            cursor: "pointer",
          }}
          onClick={closeFunc}
        >
          CLOSE
        </Typography>
      </Box>
      <Box flexGrow={1}>
        <Container maxWidth={false} sx={{ height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              flexDirection: "column",
            }} // Ensure Box also takes full height of its parent
          >
            <Box
                sx={{
                  height: "80px",
                  width: "80px",
                  backgroundImage: `url(${AshokaChakra})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  mb:"20px"
                }}
                className={Styles.loader}
              />

            {vehRegNo && <NumberPlate regNo={vehRegNo} />}
            <Fade in={showText} timeout={500}>
              <Typography
                fontSize={"1rem"}
                fontWeight={500}
                color={COLORS.PRIMARY}
                sx={{
                  mt: "20px",
                  opacity: "0.8",
                }}
              >
                {loadingText[currentTextIndex]}
              </Typography>
            </Fade>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

DetailLoading.propTypes = {
  closeFunc: PropTypes.func,
  vehRegNo: PropTypes.string,
};

export default DetailLoading;
